<script setup lang="ts">
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import AccountPanelPersonalMissingDataAlert from '../AccountPanelPersonalMissingDataAlert.vue'
import AccountPanelPersonalMissingVerificationAlert from '../AccountPanelPersonalMissingVerificationAlert.vue'
import { generateCryptoWalletRequestBody } from '../../../../utilities/account/useCryptoWallet'
import AccountCryptoWallet from '../../AccountCryptoWallet.vue'

const state = usePersonalAccountDataState()
</script>

<template>
    <div>
        <AccountPanelPersonalMissingDataAlert
            v-if="!state.hasAllRequiredNaturalProfileAttributesForInvestment"
            inline
            :description-text="$t('crypto_wallet.complete_data_description_for_crypto_wallet')"
            class="my-9" />
        <AccountPanelPersonalMissingVerificationAlert
            v-else-if="!state.naturalProfile.kyc_id"
            inline
            :description-text="$t('crypto_wallet.complete_verification_description_for_crypto_wallet')"
            :title-text="$t('verification.kyc_process')"
            :show-button="true"
            class="my-9"></AccountPanelPersonalMissingVerificationAlert>
        <AccountCryptoWallet
            v-else
            :request-body="
                generateCryptoWalletRequestBody('natural', state.naturalProfile.natural_profile_uid)
            "></AccountCryptoWallet>
    </div>
</template>
